export default () => m.route().includes(app.route('index.filter', { filter: 'following' }));
